<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.89258 1.45508V9.52167"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M6.3418 18.5528L17.4496 13.2444C18.2746 12.8503 18.7235 11.9437 18.536 11.0486L18.3078 9.95703"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M5.06929 4.83388C5.98128 4.83388 6.7206 4.09457 6.7206 3.18257C6.7206 2.27057 5.98128 1.53125 5.06929 1.53125C4.15729 1.53125 3.41797 2.27057 3.41797 3.18257C3.41797 4.09457 4.15729 4.83388 5.06929 4.83388Z"
      fill="var(--primary-blue)"
    />
    <path
      d="M13.0735 8.66757C12.77 8.46355 12.3837 8.42402 12.0445 8.56173L8.82345 9.77312L7.60951 7.32356C7.17469 6.44626 6.11121 6.08794 5.23519 6.52277C4.35788 6.9576 3.99957 8.01979 4.43439 8.8971L5.77202 12.0352C6.08061 12.6588 6.70926 13.0209 7.36086 13.0209C7.54958 13.0209 7.74085 12.989 7.92702 12.9253C8.00353 12.9125 8.07877 12.8909 8.154 12.8603L11.361 11.6552V14.2196C11.361 14.8265 11.8532 15.32 12.4615 15.32C13.0697 15.32 13.5619 14.8278 13.5619 14.2196V9.82796C13.5619 9.46199 13.3796 8.87032 13.0761 8.6663L13.0735 8.66757Z"
      fill="var(--primary-blue)"
    />
    <path
      d="M2.94629 8.81836L4.62949 12.5635C5.25048 13.9445 6.8559 14.5846 8.25601 14.0082L8.89103 13.7468"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
